<script>
import InputLine from '@/components/atoms/inputlib/components/InputLine'
import FormValidation from '@/components/atoms/FormValidation'

export default {
    name: 'Step2',
    components: {
        InputLine,
        FormValidation,
    },
    model: {
        prop: 'address',
        event: 'change',
    },
    props: {
        address: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        addressValue: {
            get() {
                return this.address
            },
            set(address) {
                this.$emit('change', address)
            },
        },
    },
    methods: {
        verifyStep() {
            this.$refs.form.formSubmit()
        },
        next() {
            this.$emit('next', 0)
        },
    },
}
</script>
<template lang="pug">
form-validation(@submit="next" ref="form")
    input-line(
        v-model="addressValue.name"
        validate="name"
        :max="255"
        :placeholder="$t('details.placeholder.address_name')"
        live required) {{$t('details.address_name')}}
</template>
